import React, { useRef, useState } from 'react';
import cn from 'classnames';
import { Transition } from '@headlessui/react';
import useOutsideClick from '@rooks/use-outside-click';

import { Button } from './Button';
import { IconDownChevron } from './Icons';

interface SelectProps {
  label: string;
  origin?: 'left' | 'right';
}

const Select: React.FC<SelectProps> = ({ label, children, origin = 'left' }) => {
  const [showDdNav, setShowDdNav] = useState(false);
  const ddRef = useRef(document.createElement('div'));
  useOutsideClick(ddRef, () => setShowDdNav(false));

  return (
    <div ref={ddRef} className="relative inline-block text-left">
      <Button onClick={() => setShowDdNav(!showDdNav)}>
        {label}
        <IconDownChevron className={cn('w-6 h-6 transform ml-1', { 'rotate-180': showDdNav })} />
      </Button>

      <Transition
        show={showDdNav}
        as="div"
        className={cn(
          'absolute mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10',
          {
            'origin-top-left left-0': origin === 'left',
            'origin-top-right right-0': origin === 'right',
          },
        )}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <div className="py-1">{children}</div>
      </Transition>
    </div>
  );
};

export default Select;
